import { useTranslation } from 'react-i18next'

export default function usePlaceholderSentenceText() {
  const { t } = useTranslation('project', { useSuspense: true })

  const placeholderSentenceText = t('여기를 더블 클릭하여 여러 문장을 한 번에 입력할 수 있습니다.')

  return { placeholderSentenceText }
}
